module.exports = __webpack_public_path__ + "img/4.c93d4f9a.png";